import { Injectable, TransferState, makeStateKey } from '@angular/core';
import { Router } from '@angular/router';
import { MktContentService } from './mkt-content.service';
import { MktEnvironmentService } from './mkt-environment.service';
const IS_DEV_MODE = makeStateKey<boolean>('isInternal');
const IS_THROTTLE_KEY = makeStateKey<boolean>('throttle');
@Injectable({
  providedIn: 'root'
})
export class RouteValidatorService {
  private disabledProducts: Array<string> = [];
  private aemMigratedPages: Array<string> = [];
  private disabledURLs: Array<string> = [];
  private isInternal: boolean = false;

  constructor(
    private router: Router,
    private _mktContentService: MktContentService,
    private _transferState: TransferState) {
    this.isInternal = this._transferState.get(IS_DEV_MODE, false);
  }

  isValidRoute(routeUrl = ''): boolean {
    if (this.disabledURLs.length === 0) this.getRouteConfigContent();
    console.log('disabledURLs:', this.disabledURLs);
    const newUrl = routeUrl.split('?')[0];
    if (this.disabledURLs?.some(url => url === newUrl)) this.router.navigateByUrl('page-not-found');
    else return true;
  }

  isPublishedProducts(pIDs: Array<string>): boolean {
    if (this.disabledProducts.length === 0) this.getRouteConfigContent();
    console.log('disabledProducts:', this.disabledProducts);
    return !(pIDs.length > 0 && this.disabledProducts?.some((v) => pIDs?.includes(v)));
  }

  isAEMMigratedPage(routeUrl: string): boolean {
    if (this.aemMigratedPages.length === 0) this.getRouteConfigContent();
    console.log('aemMigratedPages:', this.aemMigratedPages);
    const newUrl = routeUrl.split('?')[0];
    const throttle = this._transferState.get(IS_THROTTLE_KEY, null);
    return throttle ?? this.aemMigratedPages.includes(newUrl.split('/')[1]);
  }

  private getRouteConfigContent() {
    const routeConfigContent = this._mktContentService.get('Branding', 'copy', 'route_config', undefined);
    this.aemMigratedPages = JSON.parse(routeConfigContent?.aemMigratedPages || '[]');
    if (!this.isInternal) {
      this.disabledProducts = JSON.parse(routeConfigContent?.disableProducts || '[]');
      this.disabledURLs = JSON.parse(routeConfigContent?.TEXT || '[]');
    }
  }

}
